const makeFilters = text => {
    // return an array of regex to allow AND queries
    if (!text) return [/\w+/i];

    // treat comma separated non-blank words as an OR query - only one regex needed for that
    if (/,/.test(text)) return [new RegExp(text.split(/,/).filter(Boolean).map(w => w.trim()).join('|'), 'i')];

    // treat space separated non-blank words as an AND query
    return text.split(/\s+/).filter(Boolean)
        .map(w => new RegExp(w, 'i'));
}

export default makeFilters;